export class ActionConfirmModel {
    title:string;
    body:string;
    textButtonConfirm:string;
    buttonConfirmVisible:boolean;
    textButtonCancel:string;
    buttonCancelVisible:boolean;
    constructor(obj?:any){
        this.buttonConfirmVisible = true;
        this.buttonCancelVisible = true;
        if(obj){
            this.title = obj.title?obj.title:'';
            this.body = obj.body?obj.body:'';
            this.buttonConfirmVisible = this.buttonConfirmVisible?this.buttonConfirmVisible:true;
            this.buttonCancelVisible = this.buttonCancelVisible?this.buttonCancelVisible:true;
            this.textButtonConfirm = obj.textButtonConfirm?obj.textButtonConfirm:'Conferma';
            this.textButtonCancel = obj.textButtonCancel?obj.textButtonCancel:'Annulla';
        }
    }
}